module.exports = __webpack_public_path__ + "static/img/not_found.98a5b0c.gif";


//////////////////
// WEBPACK FOOTER
// ./static/image/not_found.gif
// module id = 73LF
// module chunks = 0